import { Component, OnInit } from '@angular/core';
import { EcryptServiceService } from 'src/app/services/ecrypt-service.service';
import { CrmsettingsService } from 'src/app/services/crmsettings.service';

@Component({
  selector: 'calsoft-lead-dynamic-xl',
  templateUrl: './lead-dynamic-xl.component.html',
  styleUrls: ['./lead-dynamic-xl.component.scss']
})
export class LeadDynamicXlComponent implements OnInit {
  enableSequences: number = 0;

  constructor(
    private ecryptService: EcryptServiceService,
    private crmsettingsService: CrmsettingsService,
  ) {}

  ngOnInit(): void {
    this.getAllCrmData();
  }

  getAllCrmData() {
    // First try to load from localStorage (fast path)
    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);
        if (data != null) {
          this.enableSequences = Number(data['enableSequences']) || 0;
        }
      } catch (error) {}
    }

    // Always fetch fresh from backend to avoid stale localStorage
    this.crmsettingsService.getCrmSettingsData().subscribe(
      (setting: any) => {
        if (setting != null) {
          this.enableSequences = Number(setting['enableSequences']) || 0;
          // Refresh localStorage cache
          const encryptedCrmSettings = this.ecryptService.encryptionAES(JSON.stringify(setting));
          localStorage.setItem('crmSettingsData', encryptedCrmSettings);
        }
      },
      (err) => {
        // Keep the value loaded from localStorage on error
      }
    );
  }

}
